import React from 'react';
import styled, { css } from 'styled-components';
import { Icon, IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { SortOrder } from '@ardoq/api-types';

const SortIconStyle = styled(Icon)`
  color: ${colors.iconAction};
  font-size: 20px;
  line-height: 1em;
  margin-left: 10px;
  vertical-align: bottom;
`;

export const SortIcon = ({ order, ...props }: { order: SortOrder }) => (
  <SortIconStyle
    {...props}
    iconName={
      order === SortOrder.ASC ? IconName.ARROW_UPWARD : IconName.ARROW_DOWNWARD
    }
  />
);
SortIcon.displayName = 'SortIcon';

/** @deprecated Use `@ardoq/table` instead. */
export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  border: 1px solid ${colors.borderSubtle};
`;
Table.displayName = 'Table';

export const Thead = styled.thead`
  background-color: ${colors.surfaceDefaultSubtle};
  border-bottom: 1px solid ${colors.borderSubtle};
`;
Thead.displayName = 'Thead';

export const Tr = styled('tr')<{
  // number added here, just to allow simplifications like index%2
  $even?: boolean | number;
}>`
  td {
    background-color: ${props =>
      props.$even ? colors.surfaceDefaultSubtle : colors.surfaceDefault};
  }
`;
Tr.displayName = 'Tr';

export const Th = styled.th`
  font-weight: 400;
  text-transform: uppercase;
  text-align: left;
  color: ${colors.textDefault};
  padding: 12px;
  font-size: 14px;

  &:empty {
    height: 45px;
  }

  ${props =>
    props.onClick &&
    css`
      cursor: pointer;
      &:hover {
        background: ${colors.surfaceHover};
      }
    `}
`;
Th.displayName = 'Th';

export const Tbody = styled.tbody``;
Tbody.displayName = 'Tbody';

export const Tfoot = styled.tfoot``;
Tfoot.displayName = 'Tfoot';

export const Td = styled.td`
  color: ${colors.textDefault};
  border-bottom: 1px solid ${colors.borderSubtle};
  padding: 12px;
  font-size: 14px;

  &:only-child {
    border-bottom: none;
  }

  &:empty {
    height: 45px;
  }

  a {
    cursor: pointer;
    color: ${colors.textAction};
    &:hover {
      text-decoration: underline;
      color: ${colors.textActionHover};
    }
  }
`;
Td.displayName = 'Td';

export const ResultsLabel = styled.div`
  padding: 12px 0;
  line-height: 30px;
  text-transform: uppercase;
  color: ${colors.textModerate};

  span {
    text-transform: none;
    padding-left: 10px;
    font-size: 0.8em;
    line-height: 1em;
    display: none;
    color: ${colors.textDefault};
  }

  &:hover {
    span {
      display: inline;
    }
  }
`;
ResultsLabel.displayName = 'ResultsLabel';

export const ScrollableBody = styled.div`
  overflow-y: auto;
  border-bottom: 1px solid ${colors.borderSubtle};
`;
ScrollableBody.displayName = 'ScrollableBody';
